import { FILE_IMAGE_ADD, FILE_IMAGE_ADD_ERROR } from './types'

const initialState = {
	loading: false,
	errors: [],
	image: '',
}

export const state = { ...initialState }

export default {
	[FILE_IMAGE_ADD]: (state, data) => {
		state.image = data
	},

	[FILE_IMAGE_ADD_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},
}
